import React, {useEffect} from 'react';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';
import ReferralSection from '../../PageComponent/ProfilePage/ReferralSection';

function MobileReferral() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <div className="text-coalBlack pb-[20%] ">
      <MobileProfileTopNavigation pageTitle={'Invite a Friend'} />
      <ReferralSection />
    </div>
  );
}

export default MobileReferral;
